import * as React from "react"
import LinkBtn from "./link-btn"

export default function Links({ data }) {
  return (
    data && (
      <div className="flex flex-wrap gap-4 mb-3">
        {data.map((item, i) => {
          return (
            <LinkBtn
              link={item.link}
              className={item.style + ''}
              key={`links-item-${i}`}
            />
          )
        })}
      </div>
    )
  )
}
